import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentBlock } from '../../models';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-play-cta-end',
  templateUrl: './content-block-play-cta-end.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockPlayCtaEndComponent extends ContentBlockBaseComponent {
  get splitBlockTitle() {
    return this.block.title.split('');
  }
}
